import React, { useState, useEffect } from 'react';
import togeojson from '@mapbox/togeojson';
import * as shapefile from 'shapefile';
import proj4 from 'proj4';
import jszip from 'jszip';
import SPW from "string-pixel-width";
import MaterialIcon from '../../components/MaterialIcon';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { notification } from 'antd';
import Config from '../../constants/appConfig';
import * as turf from '@turf/turf';
//import { InsertLinkRounded } from '@material-ui/icons';

class AppList extends React.Component {
    state = {
        listItens: [],
        selectItens: [],
        selectedTypeName: '2',
        selectedTypeColumn: '0',
        hasName: true,
        listTypes: [],
        filtro: '',
        id_clientImport: 0,
        id_propertyImport: 0,
        id_folderImport: 0,
        fazenda_clientImport: [],
        foldersImport: [],
        foldersTreeImport: [],
        importDefaultColor: '#2F80ED',
        colorEditingIndex: null
    };
    shift = false;

    componentDidMount() {

    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.open !== this.props.open) {
            if (this.props.selected) this.selecedItens(this.props.selected);
        }
    }

    getFileExtension = fileName => {
        const parts = String(fileName || '').toLowerCase().split('.');
        return parts.length > 1 ? parts.pop() : '';
    };

    getFileBaseName = fileName => String(fileName || '').replace(/\.[^.]+$/, '').toLowerCase();

    readSelectedFile = (file, asText = false) => new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        fileReader.onload = () => resolve(fileReader.result);
        fileReader.onerror = () => reject(fileReader.error);

        if (asText) {
            fileReader.readAsText(file);
        } else {
            fileReader.readAsArrayBuffer(file);
        }
    });

    notifyUnsupportedFile = (description) => {
        notification.open({
            message: this.props.res.ERRO,
            description: description || this.props.res.MSG_ERRO_ARQUIVO_NAO_SUPORTADO,
            icon: <MaterialIcon icon="error" className="text-danger" />
        });
    };

    getDbfEncoding = cpgText => {
        const encoding = String(cpgText || '').trim();

        if (!encoding) {
            return undefined;
        }

        if (encoding === '65001') {
            return 'utf-8';
        }

        return /^\d+$/.test(encoding) ? `windows-${encoding}` : encoding;
    };

    transformShapeCoordinates = (coordinates, transformer) => {
        if (!Array.isArray(coordinates)) {
            return coordinates;
        }

        if (coordinates.length >= 2 &&
            typeof coordinates[0] === 'number' &&
            typeof coordinates[1] === 'number') {
            const transformed = transformer.forward([coordinates[0], coordinates[1]]);

            if (!Number.isFinite(transformed[0]) || !Number.isFinite(transformed[1]) ||
                transformed[0] < -180 || transformed[0] > 180 ||
                transformed[1] < -90 || transformed[1] > 90) {
                throw new Error('A projeção do Shapefile não gerou coordenadas WGS84 válidas.');
            }

            return coordinates.length > 2
                ? [transformed[0], transformed[1], ...coordinates.slice(2)]
                : transformed;
        }

        return coordinates.map(item => this.transformShapeCoordinates(item, transformer));
    };

    transformShapeGeometry = (geometry, transformer) => {
        if (!geometry) {
            return geometry;
        }

        if (geometry.type === 'GeometryCollection') {
            geometry.geometries = geometry.geometries.map(item =>
                this.transformShapeGeometry(item, transformer)
            );
        } else {
            geometry.coordinates = this.transformShapeCoordinates(geometry.coordinates, transformer);
        }

        return geometry;
    };

    validateGeographicCoordinates = geometry => {
        const result = {
            hasCoordinates: false,
            isValid: true
        };

        const validate = coordinates => {
            if (!Array.isArray(coordinates) || !result.isValid) {
                return;
            }

            if (coordinates.length >= 2 &&
                typeof coordinates[0] === 'number' &&
                typeof coordinates[1] === 'number') {
                result.hasCoordinates = true;
                result.isValid = Number.isFinite(coordinates[0]) &&
                    Number.isFinite(coordinates[1]) &&
                    coordinates[0] >= -180 && coordinates[0] <= 180 &&
                    coordinates[1] >= -90 && coordinates[1] <= 90;
                return;
            }

            coordinates.forEach(validate);
        };

        if (geometry && geometry.type === 'GeometryCollection') {
            geometry.geometries.forEach(item => {
                const validation = this.validateGeographicCoordinates(item);
                result.hasCoordinates = result.hasCoordinates || validation.hasCoordinates;
                result.isValid = result.isValid && validation.isValid;
            });
        } else if (geometry) {
            validate(geometry.coordinates);
        }

        return result;
    };

    canAssumeWgs84 = features => {
        let hasCoordinates = false;
        let isValid = true;

        features.forEach(feature => {
            const validation = this.validateGeographicCoordinates(feature.geometry);
            hasCoordinates = hasCoordinates || validation.hasCoordinates;
            isValid = isValid && validation.isValid;
        });

        return hasCoordinates && isValid;
    };

    getShapeTransformer = prjText => {
        const projection = String(prjText || '');

        // Arquivos criados com "Define Projection" podem apenas rotular
        // coordenadas geográficas já existentes com um datum presumido.
        // Reprojetar esses dados introduz um deslocamento artificial.
        if (/GCS[_\s]+Assumed[_\s]+Geographic/i.test(projection)) {
            return {
                forward: coordinates => coordinates.slice(0, 2)
            };
        }

        return proj4(projection, 'WGS84');
    };

    parseShapefile = async (shpBuffer, prjText, dbfBuffer, cpgText) => {
        const options = {};
        const encoding = this.getDbfEncoding(cpgText);

        if (encoding) {
            options.encoding = encoding;
        }

        const track = await shapefile.read(shpBuffer, dbfBuffer || null, options);
        track.features = track.features
            .filter(feature => feature && feature.geometry);

        if (!String(prjText || '').trim()) {
            if (!this.canAssumeWgs84(track.features)) {
                throw new Error('O arquivo .shp sem .prj possui coordenadas fora do formato de longitude/latitude. Inclua o arquivo .prj para informar a projecao correta.');
            }

            return track;
        }

        const transformer = this.getShapeTransformer(prjText);

        track.features = track.features.map(feature => {
            feature.geometry = this.transformShapeGeometry(feature.geometry, transformer);
            return feature;
        });

        return track;
    };

    loadShapefile = async (shpFile, selectedFiles) => {
        const baseName = this.getFileBaseName(shpFile.name);
        const findPart = extension => selectedFiles.find(file =>
            this.getFileBaseName(file.name) === baseName &&
            this.getFileExtension(file.name) === extension
        );
        const prjFile = findPart('prj');
        const dbfFile = findPart('dbf');
        const cpgFile = findPart('cpg');

        try {
            const [shpBuffer, prjText, dbfBuffer, cpgText] = await Promise.all([
                this.readSelectedFile(shpFile),
                prjFile ? this.readSelectedFile(prjFile, true) : Promise.resolve(null),
                dbfFile ? this.readSelectedFile(dbfFile) : Promise.resolve(null),
                cpgFile ? this.readSelectedFile(cpgFile, true) : Promise.resolve(null)
            ]);
            const track = await this.parseShapefile(shpBuffer, prjText, dbfBuffer, cpgText);
            this.writeFileMap(track);
        } catch (error) {
            this.notifyUnsupportedFile(error.message);
        }
    };

    loadZippedShapefiles = async zipFile => {
        try {
            const buffer = await this.readSelectedFile(zipFile);
            const archive = await new jszip().loadAsync(buffer);
            const files = Object.keys(archive.files)
                .map(path => archive.files[path])
                .filter(file => !file.dir && file.name.indexOf('__MACOSX/') === -1);
            const shpFiles = files.filter(file => this.getFileExtension(file.name) === 'shp');

            if (shpFiles.length === 0) {
                throw new Error('O ZIP não contém um arquivo .shp.');
            }

            for (let index = 0; index < shpFiles.length; index++) {
                const shpFile = shpFiles[index];
                const baseName = this.getFileBaseName(shpFile.name);
                const findPart = extension => files.find(file =>
                    this.getFileBaseName(file.name) === baseName &&
                    this.getFileExtension(file.name) === extension
                );
                const prjFile = findPart('prj');
                const dbfFile = findPart('dbf');
                const cpgFile = findPart('cpg');

                const [shpBuffer, prjText, dbfBuffer, cpgText] = await Promise.all([
                    shpFile.async('arraybuffer'),
                    prjFile ? prjFile.async('string') : Promise.resolve(null),
                    dbfFile ? dbfFile.async('arraybuffer') : Promise.resolve(null),
                    cpgFile ? cpgFile.async('string') : Promise.resolve(null)
                ]);
                const track = await this.parseShapefile(shpBuffer, prjText, dbfBuffer, cpgText);

                this.writeFileMap(track);
            }
        } catch (error) {
            this.notifyUnsupportedFile(error.message);
        }
    };

    //upload de arquivos KML e KMZ
    loadFile = file => {
        this.itens_import = [];
        this.listItens = [];
        this.name_i = -1;
        this.setState({ listItens: [] });
        const selectedFiles = Array.from(file.target.files);
        for (let index = 0; index < selectedFiles.length; index++) {
            const filePath = selectedFiles[index];
            setTimeout(() => {
                const extension = this.getFileExtension(filePath.name);
                if (extension === 'kml') {
                    const fileReader = new FileReader();
                    fileReader.onloadend = ((e) => {
                        const content = fileReader.result;
                        let parser = new DOMParser();
                        let xmlDoc = parser.parseFromString(content, "text/xml");
                        let track = new togeojson['kml'](xmlDoc);

                        this.writeFileMap(track);
                    });
                    fileReader.readAsText(filePath);
                } else if (extension === 'kmz') {
                    let getDom = xml => (new DOMParser()).parseFromString(xml, "text/xml")
                    let getKmlDom = (kmzFile) => {
                        let zip = new jszip()
                        return zip.loadAsync(kmzFile)
                            .then(zip => {
                                let kmlDom = null
                                zip.forEach((relPath, file) => {
                                    if (this.getFileExtension(relPath) === 'kml') {
                                        kmlDom = file.async("string").then(getDom)
                                    }
                                })
                                return kmlDom || Promise.reject("No kml file found")
                            });
                    }
                    let geoJson = getKmlDom(filePath).then(kmlDom => {
                        let geoJsonObject = new togeojson['kml'](kmlDom);
                        return geoJsonObject
                    })
                    geoJson.then(gj => this.writeFileMap(gj))
                } else if (extension === 'zip') {
                    this.loadZippedShapefiles(filePath);
                } else if (extension === 'shp') {
                    this.loadShapefile(filePath, selectedFiles);
                } else if (extension === 'dbf' || extension === 'prj' || extension === 'cpg') {
                    return;
                } else if (extension === 'zjob') {
                    this.uploadFile(filePath);
                } else {
                    this.notifyUnsupportedFile();
                }
            }, 50);
        };

        document.getElementById('contained-button-file').value = null;
        //
    };

    uploadFile = (file) => {
        //this.setState({ progress: true });

        let apiUrl = Config.server + '/getPolygon';
        let method = 'POST';

        const formData = new FormData();//URLSearchParams

        formData.append('type', 'P');
        formData.append('file', file);

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }


        fetch(apiUrl, options)
            .then((fRes) => {
                if (fRes.status !== 200) throw fRes;
                else return fRes.json();
            })
            .then(
                (result) => {
                    if (result.polygons) {
                        if (result.polygons.length > 0) {
                            let list = [];
                            for (let i = 0; i < result.polygons.length; i++) {
                                const element = result.polygons[i];
                                element.poly.properties.name = element.name;
                                list.push(element.poly);
                            }
                            this.writeFileMap(turf.featureCollection(list));
                        } else {
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        //link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    //monta lista de polygons do arquivo 
    itens_import = [];
    listItens = [];
    name_i = -1;
    writeFileMap = (track) => {
        let hasName = true;
        let listTypes = [];//this.state.listTypes;
        let selectedTypeColumn = '';
        for (let i = 0; i < track.features.length; i++) {
            let feature = track.features[i];
            if (feature.geometry.type === 'Polygon' ||
                feature.geometry.type === 'GeometryCollection' ||
                feature.geometry.type === 'LineString' ||
                feature.geometry.type === 'MultiPolygon') {
                const check = (feature) => {
                    if (feature.type === 'Polygon') {
                        /*let area = turf.area(feature);
                        if (area < 5000) {
                            return false;
                        }*/
                    } else if (feature.type === 'MultiPolygon') {
                        /*let cooods = [];
                        for (let j = 0; j < feature.coordinates.length; j++) {
                            const p = turf.polygon([feature.coordinates[j]]);
                            let area = turf.area(p);
                            if (area >= 5000) {
                                cooods.push(feature.coordinates[j]);
                            }
                        }
                        if (cooods.length === 0) {
                            return false;
                        }
                        feature.coordinates = cooods;*/
                    } else if (feature.type === 'LineString') {
                        const arr1 = feature.coordinates[0];
                        const arr2 = feature.coordinates[feature.coordinates.length - 1];
                        if (arr1[0] !== arr2[0] && arr1[1] !== arr2[1]) {
                            feature.coordinates.push(feature.coordinates[0]);
                        }
                    }
                    return true;
                };
                if (feature.geometry.type === 'GeometryCollection') {
                    let geos = [];
                    let geometries = feature.geometry.geometries;
                    for (let j = 0; j < geometries.length; j++) {
                        let element = geometries[j];
                        if (check(element)) {
                            geos.push(element);
                        }
                    }
                    if (geos.length === 0) {
                        this.listItens.push(false);
                        continue;
                    }
                    feature.geometry.geometries = geos;
                } else if (feature.geometry.type === 'MultiPolygon') {
                    feature.geometry.type = 'GeometryCollection';
                    let geos = [];
                    let geometries = feature.geometry.coordinates;

                    for (let j = 0; j < geometries.length; j++) {
                        let element = {
                            "type": "Polygon",
                            "coordinates": geometries[j]
                        };
                        if (check(element)) {
                            geos.push(element);
                        }
                    }
                    if (geos.length === 0) {
                        this.listItens.push(false);
                        continue;
                    }
                    feature.geometry.geometries = geos;
                } else {
                    if (!check(feature.geometry)) {
                        this.listItens.push(false);
                        continue;
                    }
                }

                feature.properties.index = ++this.name_i;
                feature.properties.gname = 'new poly ' + (this.name_i + 1)
                if (!feature.properties.name) {
                    hasName = false;
                }
                this.listItens.push(feature.properties);
                if (listTypes.length === 0) {
                    for (var key in feature.properties) {
                        if (key !== 'gname' && key !== 'index') {
                            listTypes.push(key);
                            if (!selectedTypeColumn) {
                                selectedTypeColumn = key;
                            }
                        }
                    }
                }
            }
        }
        this.itens_import = this.itens_import.concat(track.features);
        this.setState({ listItens: this.listItens, hasName: hasName, listTypes: listTypes, selectedTypeColumn: selectedTypeColumn });
    };

    limitChar = (string, limit) => {
        let ret = string;
        let size = SPW(string, { font: "Arial", size: 16 });
        if (size > limit) {
            ret = string.slice(0, (string.length * (limit - 16) / size)) + '...';
        }
        return ret;
    };

    keyDown = (e) => {
        if (e.keyCode === 16) {
            this.shift = true;
        }
    };

    keyUp = (e) => {
        this.shift = false;
    };

    clickList = (item) => {
        let list = this.state.selectItens;
        if (this.shift) {
            let lastGuid = this.state.selectItens[this.state.selectItens.length - 1];

            let indexLast = lastGuid;
            let indexNow = item;

            if (indexNow > indexLast) {
                let c = indexNow;
                indexNow = indexLast;
                indexLast = c;
            }
            for (let i = indexNow; i <= indexLast; i++) {
                if (!this.state.selectItens.includes(i)) {
                    list.push(i);
                }
            }
        } else {
            let index = list.indexOf(item);
            if (index > -1) {
                list.splice(index, 1);
            } else {
                list.push(item);
            }
        }
        this.shift = false;
        this.setState({ selectItens: list })
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    isImportItemColorBlocked = (item) => {
        return item && (item.type === 'X' || item.type === 'XL');
    };

    getImportItemColor = (item) => {
        if (this.isImportItemColorBlocked(item)) {
            return '#ff002b';
        }

        return item && item.custom_color ? item.custom_color : this.state.importDefaultColor;
    };

    normalizeImportItemName = (value, fallback = '') => {
        if (value === null || value === undefined) {
            return fallback;
        }

        if (value instanceof Date) {
            const time = value.getTime();

            // O leitor de DBF representa datas vazias (00000000) como 1899/1900.
            if (!Number.isFinite(time) || value.getFullYear() <= 1900) {
                return fallback;
            }

            const month = String(value.getMonth() + 1).padStart(2, '0');
            const day = String(value.getDate()).padStart(2, '0');
            return `${value.getFullYear()}-${month}-${day}`;
        }

        if (typeof value === 'object') {
            try {
                const serialized = JSON.stringify(value);
                return serialized && serialized !== '{}' ? serialized : fallback;
            } catch (error) {
                return fallback;
            }
        }

        const name = String(value).trim();
        return name || fallback;
    };

    getImportItemName = item => {
        const fallback = this.normalizeImportItemName(item && item.gname);

        if (!item) {
            return fallback;
        }

        if (item.name !== null && item.name !== undefined && item.name !== '') {
            return this.normalizeImportItemName(item.name, fallback);
        }

        if (this.state.selectedTypeName === '1') {
            return this.normalizeImportItemName(item[this.state.selectedTypeColumn], fallback);
        }

        return fallback;
    };

    changeImportDefaultColor = (color) => {
        const listItens = this.state.listItens.slice();

        for (let i = 0; i < listItens.length; i++) {
            if (listItens[i] && !this.isImportItemColorBlocked(listItens[i])) {
                listItens[i].custom_color = color;
            }
        }

        this.setState({ importDefaultColor: color, listItens: listItens });
    };

    resetImportDefaultColor = (event) => {
        if (event) {
            event.stopPropagation();
        }

        this.changeImportDefaultColor('#2F80ED');
    };

    toggleImportItemColor = (event, index) => {
        if (event) {
            event.stopPropagation();
        }

        this.setState({ colorEditingIndex: this.state.colorEditingIndex === index ? null : index });
    };

    changeImportItemColor = (event, index) => {
        if (event) {
            event.stopPropagation();
        }

        const color = event.target.value;
        const listItens = this.state.listItens.slice();

        for (let i = 0; i < listItens.length; i++) {
            if (listItens[i] && Number(listItens[i].index) === Number(index)) {
                if (!this.isImportItemColorBlocked(listItens[i])) {
                    listItens[i].custom_color = color;
                }
                break;
            }
        }

        this.setState({ listItens: listItens });
    };


    estruturaPastas = (folders) => {
        let tree = [];
        let map = {};
        folders.forEach((folder) => {
            map[folder.id] = { ...folder, children: [] };
        });

        folders.forEach((folder) => {
            if (folder.id_folder_area) {
                if (map[folder.id_folder_area]) {
                    map[folder.id_folder_area].children.push(map[folder.id]);
                }
            } else {
                tree.push(map[folder.id]);
            }
        });
        return tree;
    };

    mountFoldersImport = (folders) => {
        const list = [];
        const mountList = (fs, lvl) => {
            for (let i = 0; i < fs.length; i++) {
                list.push({ ...fs[i], lvl });
                if (fs[i].children.length > 0) {
                    mountList(fs[i].children, lvl + 1);
                }
            }
        };
        mountList(folders, 0);
        this.setState({ foldersImport: list, foldersTreeImport: folders });
    };

    loadFoldersImport = (id_client) => {
        let apiUrl = Config.server + '/folder_area/client/' + id_client;
        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    const folders = result ? result.filter(item => item.id_property !== null) : [];
                    this.mountFoldersImport(this.estruturaPastas(folders));
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status !== 401 && error.status !== 403) {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    getFoldersImportFiltered = () => {
        if (this.state.id_clientImport === 0) {
            return [];
        }

        if (this.state.id_propertyImport === 0) {
            return this.state.foldersImport;
        }

        return this.state.foldersImport.filter(item => item.id_property === this.state.id_propertyImport);
    };

    getFolderImportById = (id_folder) => {
        const folders = this.state.foldersImport || [];
        for (let i = 0; i < folders.length; i++) {
            if (Number(folders[i].id) === Number(id_folder)) {
                return folders[i];
            }
        }
        return null;
    };

    getCurrentFolderImportChildren = () => {
        if (this.state.id_clientImport === 0 || this.state.id_propertyImport === 0) {
            return [];
        }

        if (this.state.id_folderImport > 0) {
            const folder = this.getFolderImportById(this.state.id_folderImport);
            return folder && folder.children ? folder.children : [];
        }

        const folders = this.state.foldersTreeImport || [];
        return folders.filter(item => Number(item.id_property) === Number(this.state.id_propertyImport));
    };

    getFolderImportPath = () => {
        let path = [];
        let folder = this.getFolderImportById(this.state.id_folderImport);

        while (folder) {
            path.unshift(folder);
            if (!folder.id_folder_area) {
                break;
            }
            folder = this.getFolderImportById(folder.id_folder_area);
        }

        return path;
    };

    getSelectedPropertyImportName = () => {
        const properties = this.state.fazenda_clientImport || [];
        for (let i = 0; i < properties.length; i++) {
            if (Number(properties[i].id) === Number(this.state.id_propertyImport)) {
                return properties[i].name;
            }
        }
        return '';
    };

    openFolderImport = (folder) => {
        this.setState({ id_folderImport: folder.id });
    };

    backFolderImport = () => {
        const folder = this.getFolderImportById(this.state.id_folderImport);
        this.setState({ id_folderImport: folder && folder.id_folder_area ? folder.id_folder_area : 0 });
    };

    handleDestinationChange = name => event => {
        const value = event.target.value;
        this.setState({ [name]: value }, () => {
            if (name === 'id_clientImport') {
                if (value > 0) {
                    if (this.props.loadProperty) {
                        this.props.loadProperty(value, (result) => {
                            this.setState({ fazenda_clientImport: result, id_propertyImport: 0, id_folderImport: 0 });
                        });
                    }
                    this.loadFoldersImport(value);
                } else {
                    this.setState({ fazenda_clientImport: [], foldersImport: [], foldersTreeImport: [], id_propertyImport: 0, id_folderImport: 0 });
                }
            } else if (name === 'id_propertyImport') {
                this.setState({ id_folderImport: 0 });
            }
        });
    };

    close = () => {
        this.setState({
            listItens: [],
            selectItens: [],
            selectedTypeName: '2',
            selectedTypeColumn: '0',
            hasName: true,
            listTypes: [],
            filtro: '',
            id_clientImport: 0,
            id_propertyImport: 0,
            id_folderImport: 0,
            fazenda_clientImport: [],
            foldersImport: [],
            foldersTreeImport: [],
            importDefaultColor: '#2F80ED',
            colorEditingIndex: null
        });
        this.props.onClose();
    };

    go = () => {
        if (this.state.listItens.length > 0) {
            let list = [];
            for (let i = 0; i < this.state.listItens.length; i++) {
                if (this.state.listItens[i]) {
                    const element = this.itens_import[this.state.listItens[i].index];
                    element.properties.name = this.getImportItemName(this.state.listItens[i]);
                    if (!this.state.listItens[i].type) {
                        element.properties.type = 'N';
                    } else {
                        element.properties.type = this.state.listItens[i].type;
                    }
                    if (element.properties.type === 'X' || element.properties.type === 'XL') {
                        element.properties.custom_color = '';
                    } else {
                        element.properties.custom_color = this.state.listItens[i].custom_color || this.state.importDefaultColor || '';
                    }
                    list.push(element);
                }
            }
            this.props.listItens(list, {
                id_client: this.state.id_clientImport > 0 ? this.state.id_clientImport : null,
                id_property: this.state.id_clientImport > 0 && this.state.id_propertyImport > 0 ? this.state.id_propertyImport : null,
                id_folder_area: this.state.id_folderImport > 0 ? this.state.id_folderImport : null
            });
            this.close();
        } else {
            this.close();
        }
    };

    render() {
        const { res, open, index } = this.props;
        const currentFolderImport = this.getFolderImportById(this.state.id_folderImport);
        const currentFolderImportChildren = this.getCurrentFolderImportChildren();

        return (
            <div className="back-quest" style={{ zIndex: index, display: open ? 'flex' : 'none' }} >
                <div className="divContentList" style={{ zIndex: index + 1, padding: '1rem' }}>
                    <div style={{ display: 'flex', width: '18rem', marginBottom: '1rem' }}>
                        <h2>{res.IMPORTAR_AREAS}</h2>
                        <div style={{ width: '50%', textAlign: 'right' }}>
                            <Button type="submit" variant="contained" color={this.state.listItens.length > 0 ? "primary" : "default"} className="popUpButton" onClick={this.go} disabled={this.state.listItens.length > 0 && this.state.id_clientImport > 0 && this.state.fazenda_clientImport.length > 0 && this.state.id_propertyImport === 0}>
                                {this.state.listItens.length > 0 ? res.IMPORTAR : res.CANCELAR}
                            </Button>
                        </div>
                    </div>
                    <label htmlFor="contained-button-file" style={{ marginBottom: '.5rem', display: 'inline-block' }}>
                        <input
                            accept=".kml,.kmz,.shp,.dbf,.prj,.cpg,.zip,.zjob"
                            style={{ display: 'none' }}
                            id="contained-button-file"
                            multiple
                            type="file" onChange={this.loadFile}
                        />
                        <label htmlFor="contained-button-file">
                            <Button size="small" component="span" variant="contained" color="primary" className="popUpButton" title={res.IMPORTAR_KMZ}>
                                <MaterialIcon icon="attach_file" className="iconMap" />
                            </Button>
                        </label>
                    </label>
                    {this.state.listItens.length > 0 &&
                        <div style={{ padding: '.5rem 0', borderBottom: 'solid 1px #c9c9c9', marginBottom: '.5rem' }}>
                            <div className='titleTextRel'>{res.MOVER_PARA}</div>
                            <Select
                                value={this.state.id_clientImport}
                                fullWidth
                                onChange={this.handleDestinationChange('id_clientImport')}
                                inputProps={{
                                    id: 'id_clientImport',
                                }}
                            >
                                <MenuItem key={0} value={0}>{res.SEM_VINCULO}</MenuItem>
                                {(this.props.clients || []).map((item, key) => {
                                    return <MenuItem key={key + '_clientImport'} value={item.id}>{item.name}</MenuItem>;
                                })}
                            </Select>
                            {this.state.id_clientImport > 0 && this.state.fazenda_clientImport.length > 0 &&
                                <div style={{ paddingTop: '.5rem' }}>
                                    <Select
                                        value={this.state.id_propertyImport}
                                        fullWidth
                                        onChange={this.handleDestinationChange('id_propertyImport')}
                                        inputProps={{
                                            id: 'id_propertyImport',
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>{res.SELECIONE}</MenuItem>
                                        {this.state.fazenda_clientImport.map((item, key) => {
                                            return <MenuItem key={key + '_propertyImport'} value={item.id}>{item.name}</MenuItem>;
                                        })}
                                    </Select>
                                </div>
                            }
                            {this.state.id_clientImport > 0 && this.state.id_propertyImport > 0 && this.getFoldersImportFiltered().length > 0 &&
                                <div style={{ paddingTop: '.5rem' }}>
                                    <div style={{ border: 'solid 1px #d8d8d8', borderRadius: '3px', padding: '.5rem', background: '#fafafa' }}>
                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '.35rem' }}>
                                            {this.getSelectedPropertyImportName()}
                                            {this.getFolderImportPath().map((folder) => {
                                                return ' > ' + folder.name;
                                            })}
                                        </div>
                                        {this.state.id_folderImport > 0 &&
                                            <Button
                                                size="small"
                                                onClick={this.backFolderImport}
                                                style={{ marginBottom: '8px' }}
                                            >
                                                <ArrowBackIcon style={{ fontSize: '18px', marginRight: '4px' }} />
                                                {res.VOLTAR}
                                            </Button>
                                        }
                                        <List style={{ maxHeight: '11rem', overflow: 'auto', padding: 0, background: '#ffffff', border: 'solid 1px #eeeeee' }}>
                                            {currentFolderImportChildren.length === 0 &&
                                                <ListItem style={{ padding: '.35rem .5rem' }}>
                                                    <ListItemText
                                                        primary={(res.PASTA) + ' ' + (currentFolderImport ? currentFolderImport.name : this.getSelectedPropertyImportName())}
                                                    />
                                                </ListItem>
                                            }
                                            {currentFolderImportChildren.map((item, key) => {
                                                return (
                                                    <ListItem key={key + '_folderImport'} button onClick={() => this.openFolderImport(item)} style={{ padding: '.35rem .5rem' }}>
                                                        <MaterialIcon icon="folder" className="iconMap" />
                                                        <ListItemText primary={item.name} style={{ paddingLeft: '.35rem' }} />
                                                        <MaterialIcon icon="keyboard_arrow_right" className="iconMap" />
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {this.state.listItens.length > 0 &&
                        <div style={{ fontSize: '16px', padding: '.5rem 0' }}>
                            {this.state.listItens.length} {res.POLIGONOS_ENCONTRADOS}
                        </div>
                    }
                    {this.state.listItens.length > 0 &&
                        <div style={{ padding: '.5rem 0', borderBottom: 'solid 1px #c9c9c9', marginBottom: '.5rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div className='titleTextRel'>{res.ALTERAR_COR_GERAL}</div>
                                <Button
                                    size="small"
                                    onClick={this.resetImportDefaultColor}
                                    style={{ minWidth: 'auto', padding: '0 .25rem', color: '#3f51b5' }}
                                >
                                    <MaterialIcon icon="replay" style={{ fontSize: '18px', marginRight: '.25rem' }} />
                                    <span style={{ fontSize: '11px' }}>{res.REINICIAR}</span>
                                </Button>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                                <input
                                    type="color"
                                    value={this.state.importDefaultColor}
                                    onChange={(event) => this.changeImportDefaultColor(event.target.value)}
                                    style={{
                                        width: '3rem',
                                        height: '2.5rem',
                                        border: 'none',
                                        cursor: 'pointer',
                                        background: 'transparent'
                                    }}
                                />
                                <span style={{ fontSize: '13px', color: '#666' }}>
                                    {this.state.importDefaultColor}
                                </span>
                            </div>
                        </div>
                    }
                    {(!this.state.hasName && this.state.listTypes.length > 0) &&
                        <div style={{ padding: '.5rem', borderBottom: 'solid 1px #c9c9c9', margin: '.5rem' }}>
                            <FormControl
                                style={{ padding: ".4rem 0 .4rem 0" }}
                                fullWidth
                                component="fieldset">
                                <div className='titleTextRel'>{'Nome do polígono'}</div>
                                <RadioGroup id="selectedTypeName" aria-label="pessoa" name="pessoa1" value={this.state.selectedTypeName} onChange={this.handleChange('selectedTypeName')}>
                                    <FormControlLabel value="2" control={<Radio color="primary" />} label={res.GERAR_NOME} />
                                    <FormControlLabel value="1" control={<Radio color="primary" />} label={res.SELECIONAR_ATRIBUTO} />
                                </RadioGroup>
                            </FormControl>
                            {this.state.selectedTypeName === "1" &&
                                <Select
                                    value={this.state.selectedTypeColumn}
                                    fullWidth
                                    onChange={this.handleChange('selectedTypeColumn')}
                                    inputProps={{
                                        id: 'id_clientPup',
                                    }}
                                >
                                    {this.state.listTypes.map((item, key) => {
                                        return <MenuItem key={key} value={item}>{item}</MenuItem>;
                                    })}
                                </Select>
                            }
                        </div>
                    }
                    <List
                        style={{ maxHeight: '60vh', overflow: 'auto' }}
                        onKeyDown={this.keyDown}
                        onKeyUp={this.keyUp}
                        component="nav"
                        aria-labelledby="areas"
                        fullWidth
                    >
                        {this.state.selectItens && this.state.listItens
                            //.filter((item) => {
                            //  return (item.name.toUpperCase().includes(filtro.toUpperCase()));
                            //})
                            .map((item, index) => {
                                const name = this.getImportItemName(item);
                                const itemColor = this.getImportItemColor(item);
                                const itemColorBlocked = this.isImportItemColorBlocked(item);
                                return (
                                    <ListItem key={index} button
                                        style={(this.state.selectItens.indexOf(item.index) >= 0) ? { backgroungColor: '#f0f0f0 !important' } : {}}
                                        onClick={event => this.clickList(item.index)}
                                        title={name}
                                    >
                                        <ListItemText id={index + 'i'} primary={name} />
                                        <input
                                            type="color"
                                            value={itemColor}
                                            onClick={(event) => event.stopPropagation()}
                                            onChange={(event) => this.changeImportItemColor(event, item.index)}
                                            title={itemColorBlocked ? 'Área de exclusão' : res.ALTERAR_COR}
                                            disabled={itemColorBlocked}
                                            style={{
                                                width: '2.5rem',
                                                height: '2rem',
                                                border: 'none',
                                                cursor: itemColorBlocked ? 'default' : 'pointer',
                                                background: 'transparent',
                                                marginLeft: '.5rem',
                                                flex: '0 0 auto'
                                            }}
                                        />
                                    </ListItem>
                                )
                            })}
                    </List>
                </div>
                <div className="div-select" onClick={this.close}></div>
            </div>
        )
    }
}

export default AppList;
